module.exports = __webpack_public_path__ + "img/nba-2k21.af3f2a0c.png";